import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { App } from "./App";
import { installGlobalErrorHandlers } from "./lib/errors";
import { startAppUpdates } from "./offline/appUpdate";

installGlobalErrorHandlers();
// Decision 103 a: register the service worker and look for a new version each time the app is back in view.
startAppUpdates();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
